import { Component, OnInit } from '@angular/core';
import { CandidateStore } from '../../../store/candidate-store';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Resume } from '../../../../shared/models/resume';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { DataService } from 'src/app/dashboards/services/data.service';
import { Router } from '@angular/router';
import { Profile } from '../../../../shared/models/profile';
import { ComponentTypes } from 'src/app/shared/enums/component-type';
import { Certificate } from '../../../../shared/models/certificate';

@Component({
  selector: 'app-dashboard-candidate-resume',
  templateUrl: './dashboard-resume.component.html',
  styleUrls: ['./dashboard-resume.component.scss'],
})
export class DashboardCandidateResumeComponent implements OnInit {
  collapse_education: boolean = true;
  showEducationCap: boolean = false;
  collapse_experience: boolean = true;
  showBriefCase: boolean = false;
  collapse_skills: boolean = true;
  collapse_certifications: boolean = true;
  collapse_portfolio: boolean = false;
  accountId: string;
  resumeId: string;
  form: FormGroup;
  componentTypes = ComponentTypes;
  constructor(
    public formBuilder: FormBuilder,
    public dashboardState: CandidateStore,
    public dataService: DataService,
    public uiState: UiStateStore,
    public router: Router
  ) {
    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }

      this.accountId = user.accountId;
    });

    this.form = this.formBuilder.group({
      resumeId: [''],
      aboutMe: [''],
    });

    this.dashboardState.resume.subscribe((res) => {
      if (!res) {
        return;
      }

      this.resumeId = res.id;
      this.form.patchValue({ resumeId: res.id });
      this.form.patchValue({ aboutMe: res.aboutMe });

      if (res.educations.length > 0) {
        this.showEducationCap = true;
      }

      if (res.experiences.length > 0) {
        this.showBriefCase = true;
      }

      if (res.skills.length > 0) {
        this.collapse_skills = false;
      }

      if (res.certificates.length > 0) {
        this.collapse_certifications = false;
      }

      if (res.portfolioAttachments.length > 0) {
        this.collapse_portfolio = false;
      }
    });
  }

  ngOnInit() {
    this.getAccountResume();
  }

  getAccountResume = () => {
    this.dataService
      .getResumeByAccountId(this.accountId)
      .subscribe((resume) => {
        if (!resume) {
          return;
        }

        this.dashboardState.setResume(resume);
      });
  };

  toggleEducation(): void {
    if (this.collapse_education) {
      this.collapse_education = false;
    } else {
      this.collapse_education = true;
    }
  }

  toggleExperience(): void {
    if (this.collapse_experience) {
      this.collapse_experience = false;
    } else {
      this.collapse_experience = true;
    }
  }

  toggleSkills(): void {
    if (this.collapse_skills) {
      this.dashboardState.initialiseSkills();
      this.collapse_skills = false;
    } else {
      this.collapse_skills = true;
    }
  }

  save(): void {
    if (!this.form.valid) {
      return;
    }
    let resume = new Resume();
    resume.id = this.form.value.resumeId;
    resume.profile = new Profile();
    resume.aboutMe = this.form.value.aboutMe;
    resume.accountId = this.accountId;
    resume.educations = this.dashboardState.getEducations();
    resume.experiences = this.dashboardState.getExperiences();
    resume.skills = this.dashboardState
      .getSkills()
      .filter(
        (skill) => Object.values(skill).length > 0 && skill.title.length > 0
      );
    resume.certificates = this.dashboardState
      .getCertifications()
      .filter(
        (certificate) =>
          Object.values(certificate).length > 0 && certificate.title.length > 0
      );
    resume.portfolioAttachments = this.dashboardState.getPortfolios();
    this.dataService.saveResume(resume).subscribe(
      (res) => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });

        setTimeout(() => {
          this.router.navigate(['/search-jobs']);
        }, 1000);
      },
      (err) => {}
    );
  }

  onPreviewResume(resumeId: string) {
    window.open(`/view-candidate/${resumeId}`);
    return false;
  }

  toggleCertifications(): void {
    this.collapse_certifications = !this.collapse_certifications;
    if(!this.collapse_certifications) {
      this.dashboardState.initialiseCertificates();
    }
  }

  togglePortfoio(): void {
    this.dashboardState.setPortfolioDialogState(true);
  }

}
